export function isEqual(x: unknown, y: unknown): boolean {
  if (x === y) return true

  if (x === null || y === null || typeof x !== 'object' || typeof y !== 'object') {
    return false
  }

  const xKeys = Object.keys(x)
  const yKeys = Object.keys(y)

  if (xKeys.length !== yKeys.length) return false

  return xKeys.every(key => {
    return isEqual((x as never)[key], (y as never)[key])
  })
}
